export default function getDefaultGeoOption(geoLevel, skipNationalAsDefaultGeography){
    let geographyOption = geoLevel?.options[0] ?? null;
    // if set to skip national and the options are available, find the first one which value is not null
    if(skipNationalAsDefaultGeography && geoLevel && geoLevel.options.length > 0) {
        geographyOption = geoLevel.options.find(option => option.value !== null) ?? geographyOption;
    }
    return geographyOption;
}